module.exports = __webpack_public_path__ + "static/media/gallery-responsive.a4ac6857.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-responsive.png
// module id = 1006
// module chunks = 0